module.exports = __webpack_public_path__ + "d34d3ddeaa183682de8139dd5be3b94e.svg";